// These are the pages you can go to.
// They are all wrapped in the App component, which should contain the navbar etc
// See http://blog.mxstbr.com/2016/01/react-apps-with-pages for more information
// about the code splitting business
import { getAsyncInjectors } from './utils/asyncInjectors';

const errorLoading = (err) => {
  console.error('Dynamic page loading failed', err); // eslint-disable-line no-console
};

const loadModule = cb => (componentModule) => {
  cb(null, componentModule.default);
};

const addBreadcrumb = (node) => {
  node.breadcrumb = node.breadcrumb
    ? [ ...node.breadcrumb, node.name ]
    : [ node.name ];

  if (node.children) {
    node.children.forEach((child) => {
      child.breadcrumb = node.breadcrumb;
      addBreadcrumb(child);
    });
  }

  return node;
}

const flat = (node) => {
  const children = node.children
    ? node.children
        .map((child) => flat(child))
        .reduce((acc, cur) => [ ...acc, ...cur ], [])
    : [];
  return [ node, ...children ];
};

export default function createRoutes(store) {
  const { injectReducer } = getAsyncInjectors(store); // injectSagas
  return [
    // Dashboard pages
    {
      path: '/d/:dash',
      name: 'dashboardchild',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('./containers/Dashboard'),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([component]) => {
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    // Ticket list page
    {
      path: '/tickets',
      name: 'Ticket',
      mode: 'list',
      getComponent(location, cb) {
        const importModules = Promise.all([
          import('./containers/Ticket/ticket_list.js'),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    // Ticket single page
    {
      path: '/tickets/:id',
      name: 'Ticket',
      mode: 'view',
      getComponent(location, cb) {
        const importModules = Promise.all([
          import('./containers/Ticket/ticket.js'),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    // About page
    {
      path: '/about',
      name: 'About',
      getComponent(location, cb) {
        const importModules = Promise.all([
          import('./containers/About'),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    // Account page
    {
      path: '/account',
      name: 'Account',
      getComponent(location, cb) {
        const importModules = Promise.all([
          import('./containers/ManageAccount'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => { // [reducer, component]
          // injectReducer('account', reducer.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    // Password recovery page
    {
      path: '/request_password_recovery',
      name: 'RequestPasswordRecovery',
      getComponent(location, cb) {
        const importModules = Promise.all([
          import('./containers/RequestPasswordRecovery'),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    // Password recovery page
    {
      path: '/password_recovery',
      name: 'PasswordRecovery',
      getComponent(location, cb) {
        const importModules = Promise.all([
          import('./containers/PasswordRecovery'),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    // Plug-ins pages
    {
      path: '/p',
      getChildRoutes(partialNextState, cb) {
        if (store.getState()
                  .get('global')
                  .get('fetching')
                  .toArray()
                  .indexOf('plugins') > 0) {
          // TODO: manage not already loaded plugin
          cb(null, []);
        } else {
          const name = /^\/p\/([^/]+)/.exec(partialNextState.location.pathname)[1];
          const plugins = store.getState().get('global').get('plugins')
            .toArray()
            .filter(p => p.name === name && p.enable);
          if (plugins.length > 0) {
            require.ensure([], (require) => {
              plugins.forEach((item) => {
                // Load plug-in specific routes
                let routes = [];
                const hierarchyFile = require(`./plugins/${item.folder}/hierarchy.js`);
                const hierarchies = Object.keys(hierarchyFile);

                hierarchies.forEach((hierarchyKey) => {
                  const hierarchy = { ...hierarchyFile[hierarchyKey], breadcrumb: undefined };
                  const currentRoutes = flat(addBreadcrumb(hierarchy))
                    .map(child => ({
                      path: child.id,
                      name: child.name,
                      help: child.help && require(`./plugins/${item.folder}/${child.help}`),
                      breadcrumb: child.breadcrumb,
                      ...(child.component
                        ? { component: require(`./plugins/${item.folder}/${child.component}`).default }
                        : {}
                      ),
                      beta: child.beta,
                      ...(child.mode ? { mode: child.mode } : {})
                    }));

                  routes = routes.concat(currentRoutes);
                });

                cb(null, routes.slice(1));

                // Try to load reducer if exists
                import(`./plugins/${item.folder}/reducer.js`)
                  .then((reducer) => {
                    injectReducer(`p_${item.folder}`, reducer.default);
                  })
                  .catch(() => (console.log(`Plugin ${item.folder} reducer not loaded`)));
              });
            });
          } else {
            cb(null, []);
          }
        }
      },
    },
    {
      path: '*',
      name: 'notfound',
      getComponent(nextState, cb) {
        switch (nextState.location.pathname) {
          case '/':
            window.location.href = '/d/homepage';
            break;
          default:
            import('./containers/NotFoundPage')
              .then(loadModule(cb))
              .catch(errorLoading);
        }
      },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/routes.js